// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h4[data-v-09d70040],p[data-v-09d70040]{margin:0}.control-cell[data-v-09d70040]{min-width:85px}@media (max-width: 640px){.price-cell[data-v-09d70040]{margin-top:-35px}}\n", ""]);
// Exports
module.exports = exports;
